import { render } from "./StatsGalerieModule.vue?vue&type=template&id=79504832"
import script from "./StatsGalerieModule.vue?vue&type=script&lang=js"
export * from "./StatsGalerieModule.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__